var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShade({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 49,
    viewBox: "0 0 46 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7299 9.22343L1.95737 9.22344C1.43076 9.22344 1 8.75276 1 8.17735L1 1.42004L44.6872 1.42003L44.6872 8.17734C44.6872 8.75275 44.2565 9.22343 43.7299 9.22343Z",
    stroke: "#F57F20",
    strokeWidth: 1.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.77246 9.22327L2.77247 32.5634C2.77247 33.6644 3.59645 34.5647 4.60405 34.5647L41.3385 34.5647C42.3455 34.5647 43.1695 33.6644 43.1695 32.5634L43.1695 9.22326L2.77246 9.22327Z",
    stroke: "#F57F20",
    strokeWidth: 1.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9821 34.7374L22.9821 41.0885",
    stroke: "#F57F20",
    strokeWidth: 1.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5985 44.1697C26.5985 42.2148 25.0135 40.63 23.0578 40.63C21.1026 40.63 19.5176 42.2148 19.5176 44.1697C19.5176 46.1252 21.1026 47.71 23.0578 47.71C25.0135 47.71 26.5985 46.1252 26.5985 44.1697Z",
    stroke: "#F57F20",
    strokeWidth: 1.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShade);
export default __webpack_public_path__ + "static/media/Shade.a3defe68dcd2123dacdfd1f58d2519c7.svg";
export { ForwardRef as ReactComponent };